<script>
export default {
    name: "DischargeReport",

    data() {

        return {
            patients: [],
        };
    },

    mounted() {

        Promise.allSettled([ this.fetchDischargedPatients(), ]).then(() => {
            window.print();
        }).catch(() => {});
    },

    methods: {

        fetchDischargedPatients() {

            let url = `Admissions/GetDischargedPatientsforDateType?DateFrom=${this.$route.query.dateFrom}&DateTo=${this.$route.query.dateTo}`;
            url += this.$route.query.type ? `&Type=${this.$route.query.type}` : ``;
            url += this.$route.query.special ? `&Special=${this.$route.query.special}` : ``;
            return this.$http.get(url).then(response => {
                this.patients = response.data;
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="w-full text-center">
            <h5 class="font-medium">Discharge Report</h5>
        </div>
        <table class="table table-bordered">
            <thead class="text-xs">
                <tr class="w-full flex">
                    <th class="p-tiny w-1/12">MRN</th>
                    <th class="p-tiny w-1/6">Patient</th>
                    <th class="p-tiny w-1/12">IP NO</th>
                    <th class="p-tiny w-1/12">Ward Type</th>
                    <th class="p-tiny w-1/12">Admitted</th>
                    <th class="p-tiny w-1/12">Ward</th>
                    <th class="p-tiny w-1/12">Bed</th>
                    <th class="p-tiny w-1/12">Days</th>
                    <th class="p-tiny w-1/12">Approved By</th>
                    <th class="p-tiny w-1/6">PMode</th>
                    <th class="p-tiny w-1/12">Balance</th>
                    <th class="p-tiny w-1/12">Type</th>
                </tr>
            </thead>
            <tbody class="text-xs bg-gray-100 flex flex-col items-center">
                <tr class="w-full flex" v-for="(patient, idx) in patients" :key="idx">
                    <td class="p-tiny w-1/12">{{ patient.patientID }}</td>
                    <td class="p-tiny w-1/6">{{ patient.names }}</td>
                    <td class="p-tiny w-1/12">{{ patient.ipfileno }}</td>
                    <td class="p-tiny w-1/12">{{ patient.bed_Type }}</td>
                    <td class="p-tiny w-1/12">{{ patient.dateAdmitted | dateFormat }}</td>
                    <td class="p-tiny w-1/12">{{ patient.ward }}</td>
                    <td class="p-tiny w-1/12">{{ patient.bed }}</td>
                    <td class="p-tiny w-1/12">{{ patient.days }}</td>
                    <td class="p-tiny w-1/12">{{ patient.approvedBy }}</td>
                    <td class="p-tiny w-1/6">{{ patient.pmode }}</td>
                    <td class="p-tiny w-1/12">{{ patient.balance | numberFormat }}</td>
                    <td class="p-tiny w-1/12">{{ patient.type }}</td>
                </tr>
                <tr class="w-full flex">
                    <td class="p-tiny w-1/2"></td>
                    <td class="p-tiny w-1/2 text-right">Total Discharged Patients: {{ patients.length }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
